import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hrProps"];
import React from "react";
import styled from "styled-components";
import Grid from "../Grid";
import HR from "../HR";
import Box from "../Box";
import Text from "../Text";
import HoverText from '../HoverText';
import { useThemeDefaults } from "../utils";
import { focusVisibleStyle } from "../focus";
export var Title = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    textStyle: theme.artworkGrid.title.textStyle,
    width: "100%",
    truncate: true
  };
}, Text);
export var Item = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: "flex",
    alignItems: "center",
    pt: theme.artworkGrid.item.py,
    pb: theme.artworkGrid.item.py,
    borderBottom: theme.artworkGrid.item.borderBottom,
    borderColor: theme.artworkGrid.item.borderColor,
    height: theme.artworkGrid.item.height
  };
}, styled(Box).withConfig({
  displayName: "ArtworkGrid__Item",
  componentId: "sc-17hc9mq-0"
})(["", " &:hover,&:focus-visible{", "{color:", ";}}"], focusVisibleStyle, HoverText, function (props) {
  return props.theme.colors.ctrl;
}));
export var Artwork = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    minWidth: theme.artworkGrid.artwork.size,
    width: theme.artworkGrid.artwork.size,
    height: theme.artworkGrid.artwork.size
  };
}, Box);
export var Status = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.artworkGrid.status.color,
    textStyle: theme.artworkGrid.status.textStyle
  };
}, Text);
export var Data = useThemeDefaults(function (_ref5) {
  var theme = _ref5.theme;
  return {
    ml: theme.artworkGrid.data.ml,
    pr: theme.artworkGrid.data.pr,
    overflow: "hidden",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    justifyContent: "center"
  };
}, Box);
export var ArtworkGrid = function ArtworkGrid(_ref6) {
  var hrProps = _ref6.hrProps,
      props = _objectWithoutProperties(_ref6, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, _extends({
    gridTemplateColumns: ["minmax(0, 1fr)", "repeat(2, minmax(0, 1fr))", "repeat(3, minmax(0, 1fr))"]
  }, props)), /*#__PURE__*/React.createElement(HR, _extends({
    mt: "-1px"
  }, hrProps)));
};
ArtworkGrid.Item = Item;
ArtworkGrid.Artwork = Artwork;
ArtworkGrid.Title = Title;
ArtworkGrid.Status = Status;
ArtworkGrid.Data = Data;
export default ArtworkGrid;